import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
export function LegacyTeamAccessPage() {
  const { t } = useTranslation('dashboard');
  return (
    <main className="max-w-lg mx-auto p-6 space-y-5 text-gray-900 dark:text-white">
      <h1 className="text-2xl font-serif">{t('team.title')}</h1>
      <p>{t('team.legacyLink')}</p>
      <Link
        to="/team/invitations"
        className="block text-primary-700 dark:text-primary-300 underline"
      >
        {t('team.myInvitations')}
      </Link>
      <Link to="/login" className="block underline">
        {t('team.signIn')}
      </Link>
    </main>
  );
}
